var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Info_Icon",
    "data-name": "Info Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6245",
    "data-name": "Path 6245",
    d: "M306.5-198.5V-203h-2v1h1v3.5H304v1h4v-1Zm-.5-7a.75.75,0,0,0-.75.75.75.75,0,0,0,.75.75.75.75,0,0,0,.75-.75.75.75,0,0,0-.75-.75Zm0,11.5a7,7,0,0,1-7-7,7,7,0,0,1,7-7,7,7,0,0,1,7,7A7.008,7.008,0,0,1,306-194Zm0-13a6,6,0,0,0-6,6,6,6,0,0,0,6,6,6,6,0,0,0,6-6A6.007,6.007,0,0,0,306-207Z",
    fill: "#128370",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6244",
    "data-name": "Path 6244",
    d: "M298-193h16v-16H298Z",
    fill: "#128370"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 24,
    height: 24,
    transform: "translate(294 -213)",
    fill: "#128370"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6243",
    "data-name": "Path 6243",
    d: "M299-194h14v-14H299Z",
    fill: "#128370"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6338",
    "data-name": "Group 6338",
    transform: "translate(-299 208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6337",
    "data-name": "Group 6337",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6336",
    "data-name": "Group 6336",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6335",
    "data-name": "Group 6335",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6334",
    "data-name": "Group 6334",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6242",
    "data-name": "Path 6242",
    d: "M294-213h24v24H294Z",
    fill: "#128370"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconGreen);
export default __webpack_public_path__ + "static/media/info-icon-green.c96ada8fafdeb79a303fd3810b23adb7.svg";
export { ForwardRef as ReactComponent };